// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export interface NotEnoughPeerReviewsNextStep {
  courseId: string;
  isSessionPrivate?: boolean | null;
}

export interface CourseNextStepNotEnoughPeerReviewsNextStep {
  typeName: 'notEnoughPeerReviewsNextStep';
  definition: NotEnoughPeerReviewsNextStep;
}

export type LearnerCourseScheduleSuggestion = NoSuggestion | Extension | ShiftDeadlines;

export type ScheduleNoSuggestionReason =
  | 'NO_UNDERLYING_SESSION'
  | 'NO_DEADLINES'
  | 'ALL_DEADLINES_ON_TRACK'
  | 'SINGLE_DEADLINE_OVERDUE'
  | 'ON_STRICT_SCHEDULE'
  | 'NO_AVAILABLE_SESSION_TO_SWITCH';

export interface NoSuggestion {
  reason: ScheduleNoSuggestionReason;
}

export type ScheduleExtensionReason =
  | 'LAST_DEADLINE_IN_THE_PAST'
  | 'SINGLE_DEADLINE_OVERDUE_MORE_THAN_TWO_WEEKS'
  | 'MULTIPLE_DEADLINES_OVERDUE'
  | 'LEARNER_SUPPORT_TOOLS_SUGGESTION';

export type SwitchNotNeeded = {};

export type SessionSwitchResponse = SuggestedSwitch | SwitchNotNeeded;

export interface SubtitleTrack {
  languageCode: string;
  url: string;
}

export interface AssetData {
  assetId: string;
  subtitles: Array<SubtitleTrack>;
}

export interface RenderableHtmlMetadata {
  hasMath: boolean;
  hasCodeBlock: boolean;
  isPlainText: boolean;
  hasAssetBlock: boolean;
  assetData?: Array<AssetData> | null;
}

export interface RenderableHtmlWithMetadata {
  renderableHtml: string;
  metadata: RenderableHtmlMetadata;
}

export interface CmlContentType {
  dtdId: string;
  value: string;
  renderableHtmlWithMetadata?: RenderableHtmlWithMetadata | null;
}

export interface CmlContentCml {
  typeName: 'cml';
  definition: CmlContentType;
}

export type CmlContent = CmlContentCml;

export type CmlContentTypeName = 'cml';

export interface BranchChange {
  changesDescription: CmlContent;
}

export interface SuggestedSwitch {
  userId: number;
  sourceSessionBranchId: string;
  destinationSessionId: string;
  destinationSessionBranchId: string;
  branchChange?: BranchChange | null;
  sourceSessionId?: string | null;
}

export interface Extension {
  days: number;
  reason: ScheduleExtensionReason;
  startsAt: number;
  endsAt: number;
  progressPercentage?: number | null;
  sessionSwitch?: SessionSwitchResponse | null;
}

export type ShiftDeadlinesReason =
  | 'LAST_DEADLINE_IN_THE_PAST'
  | 'SINGLE_DEADLINE_OVERDUE_MORE_THAN_TWO_WEEKS'
  | 'MULTIPLE_DEADLINES_OVERDUE'
  | 'LEARNER_SUPPORT_TOOLS_SUGGESTION';

export interface ShiftDeadlines {
  days: number;
  reason: ShiftDeadlinesReason;
  startsAt: number;
  endsAt: number;
  progressPercentage?: number | null;
  sessionSwitch?: SessionSwitchResponse | null;
}

export interface CourseScheduleAdjustmentNextStep {
  suggestion: LearnerCourseScheduleSuggestion;
}

export interface CourseNextStepCourseScheduleAdjustmentNextStep {
  typeName: 'courseScheduleAdjustmentNextStep';
  definition: CourseScheduleAdjustmentNextStep;
}

export interface MultipleDeadlinesNextStep {
  courseId: string;
  isSessionPrivate?: boolean | null;
}

export interface CourseNextStepMultipleDeadlinesNextStep {
  typeName: 'multipleDeadlinesNextStep';
  definition: MultipleDeadlinesNextStep;
}

export interface CourseNextStepNoEnrollableSessionsNextStep {
  typeName: 'noEnrollableSessionsNextStep';
  definition: any;
}

export interface NoAvailableNextStep {
  reason: string;
}

export interface CourseNextStepNoAvailableNextStep {
  typeName: 'noAvailableNextStep';
  definition: NoAvailableNextStep;
}

export interface CourseMaterialContentSummaryTeammateReview {
  typeName: 'teammateReview';
  definition: any;
}

export interface PlaceholderItemContentSummaryDefinition {
  gradingLatePenalty?: GradingLatePenalty | null;
  learnerMessage?: string | null;
}

export interface CourseMaterialContentSummaryPlaceholder {
  typeName: 'placeholder';
  definition: PlaceholderItemContentSummaryDefinition;
}

export interface SupplementSummaryDefinition {
  assetTypeName: string;
  containsWidget: boolean;
}

export interface CourseMaterialContentSummarySupplement {
  typeName: 'supplement';
  definition: SupplementSummaryDefinition;
}

export type AssignmentFeature =
  | 'TEAMWORK'
  | 'MANUAL_GRADED_QUESTIONS'
  | 'MULTIPLE_FILLABLE_BLANKS_QUESTIONS'
  | 'WIDGET_QUESTIONS'
  | 'HIDE_GRADE_ON_RELEASE'
  | 'SHOW_GRADE_ON_RELEASE'
  | 'TAKE_LATEST_GRADE'
  | 'TAKE_HIGHEST_GRADE'
  | 'LIMITED_ATTEMPTS'
  | 'ATTEMPT_TIME_LIMITS'
  | 'LIMITED_SUBMISSIONS'
  | 'ASSIGNMENT_RUBRICS'
  | 'HIDE_LEARNER_RESPONSE_AFTER_SUBMISSION'
  | 'MULTIPLE_SUBMISSIONS'
  | 'TEXT_BLOCKS'
  | 'PROCTORING_INTEGRATION';

export interface StaffGradedSummaryDefinition {
  isTeamSubmissionEnabled: boolean;
  standardProctorConfigurationId?: string | null;
  gradingLatePenalty?: GradingLatePenalty | null;
  requiredMobileFeatures?: Array<AssignmentFeature> | null;
}

export interface CourseMaterialContentSummaryStaffGraded {
  typeName: 'staffGraded';
  definition: StaffGradedSummaryDefinition;
}

export interface UngradedWidgetSummaryDefinition {
  supportsTouch: boolean;
  minWidthPx?: number | null;
  minHeightPx?: number | null;
}

export interface CourseMaterialContentSummaryUngradedWidget {
  typeName: 'ungradedWidget';
  definition: UngradedWidgetSummaryDefinition;
}

export interface CourseMaterialContentSummaryUngradedProgramming {
  typeName: 'ungradedProgramming';
  definition: any;
}

export interface StandardPeerSummaryDefinition {
  requiredReviewCount: number;
  isMentorGraded: boolean;
}

export interface CourseMaterialContentSummaryPeer {
  typeName: 'peer';
  definition: StandardPeerSummaryDefinition;
}

export interface CourseMaterialContentSummaryUngradedLti {
  typeName: 'ungradedLti';
  definition: any;
}

export interface GradedDiscussionPromptSummaryDefinition {
  gradingLatePenalty?: GradingLatePenalty | null;
}

export interface CourseMaterialContentSummaryGradedDiscussionPrompt {
  typeName: 'gradedDiscussionPrompt';
  definition: GradedDiscussionPromptSummaryDefinition;
}

export interface LectureSummaryDefinition {
  duration?: number | null;
  hasInVideoAssessment: boolean;
}

export interface CourseMaterialContentSummaryLecture {
  typeName: 'lecture';
  definition: LectureSummaryDefinition;
}

export interface GradedWidgetSummaryDefinition {
  supportsTouch: boolean;
  minWidthPx?: number | null;
  minHeightPx?: number | null;
}

export interface CourseMaterialContentSummaryGradedWidget {
  typeName: 'gradedWidget';
  definition: GradedWidgetSummaryDefinition;
}

export interface CourseMaterialContentSummarySlideshow {
  typeName: 'slideshow';
  definition: any;
}

export interface GradedPeerSummaryDefinition {
  requiredReviewCount: number;
  isMentorGraded: boolean;
  gradingLatePenalty?: GradingLatePenalty | null;
}

export interface CourseMaterialContentSummaryGradedPeer {
  typeName: 'gradedPeer';
  definition: GradedPeerSummaryDefinition;
}

export interface AssessOpenSinglePageSummaryDefinition {
  questionCount?: number | null;
  containsWidgetQuestions: boolean;
}

export interface CourseMaterialContentSummaryAssessOpenSinglePage {
  typeName: 'assessOpenSinglePage';
  definition: AssessOpenSinglePageSummaryDefinition;
}

export interface AttemptRateLimit {
  allowedSubmissionsPerInterval: number;
  allowedSubmissionsInterval: number;
}

export interface FormativeQuizSummaryDefinition {
  questionCount: number;
  passingFraction: number;
  containsWidgetQuestions: boolean;
  requiredMobileCapabilities: Array<string>;
  maxScore: number;
  passingScore: number;
  standardProctorConfigurationId?: string | null;
  lockingConfiguration?: AttemptRateLimit | null;
}

export interface CourseMaterialContentSummaryQuiz {
  typeName: 'quiz';
  definition: FormativeQuizSummaryDefinition;
}

export interface ClosedPeerSummaryDefinition {
  requiredReviewCount: number;
  isMentorGraded: boolean;
  gradingLatePenalty?: GradingLatePenalty | null;
}

export interface CourseMaterialContentSummaryClosedPeer {
  typeName: 'closedPeer';
  definition: ClosedPeerSummaryDefinition;
}

export interface CourseMaterialContentSummaryWorkspaceLauncher {
  typeName: 'workspaceLauncher';
  definition: any;
}

export interface SingleQuestionSubmitQuizSummaryDefinition {
  questionCount?: number | null;
  containsWidgetQuestions: boolean;
}

export interface CourseMaterialContentSummarySingleQuestionSubmit {
  typeName: 'singleQuestionSubmit';
  definition: SingleQuestionSubmitQuizSummaryDefinition;
}

export interface CourseMaterialContentSummaryWiseFlow {
  typeName: 'wiseFlow';
  definition: any;
}

export interface CourseMaterialContentSummaryUngradedLab {
  typeName: 'ungradedLab';
  definition: any;
}

export interface ImmediateProgrammingSummaryDefinition {
  gradingLatePenalty?: GradingLatePenalty | null;
}

export interface CourseMaterialContentSummaryProgramming {
  typeName: 'programming';
  definition: ImmediateProgrammingSummaryDefinition;
}

export interface UngradedAssignmentSummaryDefinition {
  isTeamSubmissionEnabled: boolean;
  standardProctorConfigurationId?: string | null;
  requiredMobileFeatures?: Array<AssignmentFeature> | null;
}

export interface CourseMaterialContentSummaryUngradedAssignment {
  typeName: 'ungradedAssignment';
  definition: UngradedAssignmentSummaryDefinition;
}

export interface FixedGradingLatePenalty {
  penalty: number;
}

export interface GradingLatePenaltyFixedGradingLatePenalty {
  typeName: 'fixedGradingLatePenalty';
  definition: FixedGradingLatePenalty;
}

export type PenaltyIncrementMode =
  | 'APPLY_PENALTY_FRACTION_ON_AWARDED_SCORE'
  | 'DECREASE_PENALTY_POINTS_ON_AWARDED_SCORE';

export type PeriodType = 'ZERO' | 'MINUTE' | 'HOUR' | 'DAY' | 'WEEK' | 'MONTH' | 'INFINITY';

export interface TimePeriod {
  count: number;
  periodType: PeriodType;
}

export interface LatePenaltyIncrement {
  penalty: number;
  penaltyMode: PenaltyIncrementMode;
  applyEvery: TimePeriod;
  maxApplications?: number | null;
}

export interface LatePenaltyScoreCap {
  applyAfter: TimePeriod;
  maxFinalScore: number;
}

export interface LatePenaltyMinScoreThreshold {
  minScoreForLatePenaltyApplication: number;
}

export interface CompoundLatePenalty {
  incrementalPenalty?: LatePenaltyIncrement | null;
  maxAllowedScore?: LatePenaltyScoreCap | null;
  minScorethreshold?: LatePenaltyMinScoreThreshold | null;
}

export interface GradingLatePenaltyCompoundLatePenalty {
  typeName: 'compoundLatePenalty';
  definition: CompoundLatePenalty;
}

export interface IncrementalGradingLatePenalty {
  penalty: number;
}

export interface GradingLatePenaltyIncrementalGradingLatePenalty {
  typeName: 'incrementalGradingLatePenalty';
  definition: IncrementalGradingLatePenalty;
}

export type GradingLatePenalty =
  | GradingLatePenaltyFixedGradingLatePenalty
  | GradingLatePenaltyCompoundLatePenalty
  | GradingLatePenaltyIncrementalGradingLatePenalty;

export type GradingLatePenaltyTypeName =
  | 'fixedGradingLatePenalty'
  | 'compoundLatePenalty'
  | 'incrementalGradingLatePenalty';

export interface SummativeQuizSummaryDefinition {
  questionCount: number;
  passingFraction: number;
  containsWidgetQuestions: boolean;
  requiredMobileCapabilities: Array<string>;
  maxScore: number;
  passingScore: number;
  standardProctorConfigurationId?: string | null;
  allowedSubmissionsPerInterval: number;
  allowedSubmissionsInterval: number;
  lockingConfiguration?: AttemptRateLimit | null;
  gradingLatePenalty?: GradingLatePenalty | null;
}

export interface CourseMaterialContentSummaryExam {
  typeName: 'exam';
  definition: SummativeQuizSummaryDefinition;
}

export interface PhasedPeerSummaryDefinition {
  requiredReviewCount: number;
  isMentorGraded: boolean;
  reviewDeadlineOffset: number;
  gradingLatePenalty?: GradingLatePenalty | null;
  proctorConfigurationId?: string | null;
}

export interface CourseMaterialContentSummaryPhasedPeer {
  typeName: 'phasedPeer';
  definition: PhasedPeerSummaryDefinition;
}

export interface NotebookSummaryDefinition {
  isGradedByItem: boolean;
}

export interface CourseMaterialContentSummaryNotebook {
  typeName: 'notebook';
  definition: NotebookSummaryDefinition;
}

export interface GradedLtiSummaryDefinition {
  gradingLatePenalty?: GradingLatePenalty | null;
}

export interface CourseMaterialContentSummaryGradedLti {
  typeName: 'gradedLti';
  definition: GradedLtiSummaryDefinition;
}

export interface GradedProgrammingSummaryDefinition {
  gradingLatePenalty?: GradingLatePenalty | null;
}

export interface CourseMaterialContentSummaryGradedProgramming {
  typeName: 'gradedProgramming';
  definition: GradedProgrammingSummaryDefinition;
}

export interface CourseMaterialContentSummaryDiscussionPrompt {
  typeName: 'discussionPrompt';
  definition: any;
}

export type CourseMaterialContentSummary =
  | CourseMaterialContentSummaryTeammateReview
  | CourseMaterialContentSummaryPlaceholder
  | CourseMaterialContentSummarySupplement
  | CourseMaterialContentSummaryStaffGraded
  | CourseMaterialContentSummaryUngradedWidget
  | CourseMaterialContentSummaryUngradedProgramming
  | CourseMaterialContentSummaryPeer
  | CourseMaterialContentSummaryUngradedLti
  | CourseMaterialContentSummaryGradedDiscussionPrompt
  | CourseMaterialContentSummaryLecture
  | CourseMaterialContentSummaryGradedWidget
  | CourseMaterialContentSummarySlideshow
  | CourseMaterialContentSummaryGradedPeer
  | CourseMaterialContentSummaryAssessOpenSinglePage
  | CourseMaterialContentSummaryQuiz
  | CourseMaterialContentSummaryClosedPeer
  | CourseMaterialContentSummaryWorkspaceLauncher
  | CourseMaterialContentSummarySingleQuestionSubmit
  | CourseMaterialContentSummaryWiseFlow
  | CourseMaterialContentSummaryUngradedLab
  | CourseMaterialContentSummaryProgramming
  | CourseMaterialContentSummaryUngradedAssignment
  | CourseMaterialContentSummaryExam
  | CourseMaterialContentSummaryPhasedPeer
  | CourseMaterialContentSummaryNotebook
  | CourseMaterialContentSummaryGradedLti
  | CourseMaterialContentSummaryGradedProgramming
  | CourseMaterialContentSummaryDiscussionPrompt;

export type CourseMaterialContentSummaryTypeName =
  | 'teammateReview'
  | 'placeholder'
  | 'supplement'
  | 'staffGraded'
  | 'ungradedWidget'
  | 'ungradedProgramming'
  | 'peer'
  | 'ungradedLti'
  | 'gradedDiscussionPrompt'
  | 'lecture'
  | 'gradedWidget'
  | 'slideshow'
  | 'gradedPeer'
  | 'assessOpenSinglePage'
  | 'quiz'
  | 'closedPeer'
  | 'workspaceLauncher'
  | 'singleQuestionSubmit'
  | 'wiseFlow'
  | 'ungradedLab'
  | 'programming'
  | 'ungradedAssignment'
  | 'exam'
  | 'phasedPeer'
  | 'notebook'
  | 'gradedLti'
  | 'gradedProgramming'
  | 'discussionPrompt';

export type DeadlineStatus = 'FAILED' | 'OVERDUE' | 'ONTRACK' | 'COMPLETED';

export interface ItemGroup {
  id: string;
  requiredPassedCount: number;
  passableItemGroupChoiceIds: Array<string>;
}

export interface CompoundLatePenaltyRatio {
  ratio: number;
  penaltyContext: CompoundLatePenalty;
  submissionDeadline: number;
  submissionTime: number;
}

export interface LatePenaltyRatioCompoundLatePenaltyRatio {
  typeName: 'compoundLatePenaltyRatio';
  definition: CompoundLatePenaltyRatio;
}

export interface FixedLatePenaltyRatio {
  ratio: number;
}

export interface LatePenaltyRatioFixedLatePenaltyRatio {
  typeName: 'fixedLatePenaltyRatio';
  definition: FixedLatePenaltyRatio;
}

export interface IncrementalLatePenaltyRatio {
  ratio: number;
  duration: number;
}

export interface LatePenaltyRatioIncrementalLatePenaltyRatio {
  typeName: 'incrementalLatePenaltyRatio';
  definition: IncrementalLatePenaltyRatio;
}

export type LatePenaltyRatio =
  | LatePenaltyRatioCompoundLatePenaltyRatio
  | LatePenaltyRatioFixedLatePenaltyRatio
  | LatePenaltyRatioIncrementalLatePenaltyRatio;

export type LatePenaltyRatioTypeName =
  | 'compoundLatePenaltyRatio'
  | 'fixedLatePenaltyRatio'
  | 'incrementalLatePenaltyRatio';

export interface ItemOutcome {
  grade: number;
  isPassed: boolean;
  latePenaltyRatio?: LatePenaltyRatio | null;
}

export type ItemLockStatus = 'LOCKED_PARTIALLY_FOR_SUBMITTING' | 'LOCKED_FOR_SUBMITTING' | 'LOCKED_FULLY';

export type ItemLockedReasonCode =
  | 'PREMIUM'
  | 'PASSABLE_ITEM_COMPLETION'
  | 'PREMIUM_ITEM'
  | 'SESSION_PREVIEW'
  | 'SESSION_ENDED'
  | 'SESSION_ENDED_FOR_FLEXIBLE_SCHEDULE'
  | 'ENROLLMENT_PREVIEW'
  | 'RESTRICTED_AUDIT'
  | 'TIMED_RELEASE_CONTENT'
  | 'TIMED_SUBMISSION_LOCKED_CONTENT'
  | 'RESITTING_ITEM_LOCK_OVERRIDE'
  | 'REQUIRE_ALL_ITEM_IN_LESSON';

export interface ItemLockState {
  lockStatus: ItemLockStatus;
  reasonCode: ItemLockedReasonCode;
}

export interface TimedReleaseContentLockInfo {
  unlockedTimeStart?: number | null;
  unlockedTimeEnd?: number | null;
  timedItemLockCustomMessage?: string | null;
}

export interface ItemLockInfoTimedReleaseContentLockInfo {
  typeName: 'timedReleaseContentLockInfo';
  definition: TimedReleaseContentLockInfo;
}

export type ItemLockInfo = ItemLockInfoTimedReleaseContentLockInfo;

export type ItemLockInfoTypeName = 'timedReleaseContentLockInfo';

export interface ItemLockSummary {
  lockState: ItemLockState;
  lockInfo?: ItemLockInfo | null;
  isPreviewableByCourseStaff?: boolean | null;
}

export interface Item {
  id: string;
  name: string;
  resourcePath: string;
  trackId: string;
  isLocked: boolean;
  isOptional: boolean;
  timeCommitment: number;
  deadline?: number | null;
  contentSummary: CourseMaterialContentSummary;
  itemDeadlineStatus: DeadlineStatus;
  itemGroup?: ItemGroup | null;
  computedOutcome?: ItemOutcome | null;
  computedProgressState: string;
  gradingLatePenalty?: GradingLatePenalty | null;
  itemLockSummary?: ItemLockSummary | null;
}

export type CourseMaterialNextStepType =
  | 'STUDY_MATERIAL_ONTRACK'
  | 'STUDY_MATERIAL_OVERDUE'
  | 'QUIZ_ONTRACK'
  | 'QUIZ_OVERDUE'
  | 'PRACTICE_ASSIGNMENT_ONTRACK'
  | 'PRACTICE_ASSIGNMENT_OVERDUE'
  | 'EXAM_VERIFY'
  | 'EXAM_FAILED_TRY_AGAIN'
  | 'EXAM_FAILED_TRY_LATER'
  | 'EXAM_ONTRACK'
  | 'EXAM_OVERDUE'
  | 'GRADED_ASSIGNMENT_VERIFY'
  | 'GRADED_ASSIGNMENT_FAILED_TRY_AGAIN'
  | 'GRADED_ASSIGNMENT_FAILED_TRY_LATER'
  | 'GRADED_ASSIGNMENT_ONTRACK'
  | 'GRADED_ASSIGNMENT_OVERDUE'
  | 'GRADED_PEER_VERIFY'
  | 'GRADED_PEER_UNSUBMITTED_ONTRACK'
  | 'GRADED_PEER_UNSUBMITTED_OVERDUE'
  | 'GRADED_PEER_REVIEW_ONTRACK'
  | 'GRADED_PEER_REVIEW_OVERDUE'
  | 'GRADED_PEER_OVERDUE'
  | 'GRADED_PEER_ONTRACK'
  | 'GRADED_PEER_FAILED'
  | 'TMR_UNSUBMITTED_ONTRACK'
  | 'TMR_UNSUBMITTED_OVERDUE'
  | 'TMR_FAILED'
  | 'DEFAULT';

export interface CourseMaterialNextStep {
  item: Item;
  sessionStartedAt: number;
  currentWeekNumberByProgress: number;
  courseMaterialNextStepType: CourseMaterialNextStepType;
}

export interface CourseNextStepCourseMaterialNextStep {
  typeName: 'courseMaterialNextStep';
  definition: CourseMaterialNextStep;
}

export interface CourseMetadata {
  id: string;
  name: string;
  slug: string;
  courseType: string;
  partnerNames: Array<string>;
}

export interface NextStepCompletedS12nPartner {
  id: number;
  name: string;
  logo: string;
}

export interface S12nMetadata {
  courseIds: Array<string>;
  capstoneCourseIds: Array<string>;
  name: string;
  variant: string;
  partners: Array<NextStepCompletedS12nPartner>;
}

export interface CertificateMetadata {
  courseCertificateVerifyCode: string;
  courseCertificatePreviewImageUrl: string;
  specializationCertificateVerifyCode?: string | null;
  specializationCertificatePreviewImageUrl?: string | null;
}

export interface GradeMetadata {
  grade: number;
  completedAt: number;
}

export interface CourseCompletedNextStep {
  course: CourseMetadata;
  s12n?: S12nMetadata | null;
  enrolledCourseIds: Array<string>;
  canUpgrade: boolean;
  canUnenroll: boolean;
  canSubscribe: boolean;
  canViewCertificate: boolean;
  canCompleteVerificationProfile: boolean;
  isEligibleButNoCertificate: boolean;
  certificateMetadata?: CertificateMetadata | null;
  gradeMetadata?: GradeMetadata | null;
}

export interface CourseNextStepCourseCompletedNextStep {
  typeName: 'courseCompletedNextStep';
  definition: CourseCompletedNextStep;
}

export interface NoActiveSessionNextStep {
  courseId: string;
}

export interface CourseNextStepNoActiveSessionNextStep {
  typeName: 'noActiveSessionNextStep';
  definition: NoActiveSessionNextStep;
}

export interface NoAvailableNextStepFromError {
  reason: string;
}

export interface CourseNextStepNoAvailableNextStepFromError {
  typeName: 'noAvailableNextStepFromError';
  definition: NoAvailableNextStepFromError;
}

export interface SessionEndedNextStep {
  courseId: string;
  currentSessionEndedAt: number;
  isSessionPrivate?: boolean | null;
}

export interface CourseNextStepSessionEndedNextStep {
  typeName: 'sessionEndedNextStep';
  definition: SessionEndedNextStep;
}

export type CourseNextStep =
  | CourseNextStepNotEnoughPeerReviewsNextStep
  | CourseNextStepCourseScheduleAdjustmentNextStep
  | CourseNextStepMultipleDeadlinesNextStep
  | CourseNextStepNoEnrollableSessionsNextStep
  | CourseNextStepNoAvailableNextStep
  | CourseNextStepCourseMaterialNextStep
  | CourseNextStepCourseCompletedNextStep
  | CourseNextStepNoActiveSessionNextStep
  | CourseNextStepNoAvailableNextStepFromError
  | CourseNextStepSessionEndedNextStep;

export type CourseNextStepTypeName =
  | 'notEnoughPeerReviewsNextStep'
  | 'courseScheduleAdjustmentNextStep'
  | 'multipleDeadlinesNextStep'
  | 'noEnrollableSessionsNextStep'
  | 'noAvailableNextStep'
  | 'courseMaterialNextStep'
  | 'courseCompletedNextStep'
  | 'noActiveSessionNextStep'
  | 'noAvailableNextStepFromError'
  | 'sessionEndedNextStep';

export interface GuidedCourseNextStepsV1 {
  id: string;
  nextStep: CourseNextStep;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface GuidedCourseNextStepsV1Connection {
  elements: Array<GuidedCourseNextStepsV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface GuidedCourseNextStepsV1MultiGetQuery {
  GuidedCourseNextStepsV1: {
    multiGet: GuidedCourseNextStepsV1Connection | null;
  } | null;
}

export interface GuidedCourseNextStepsV1MultiGetQueryVariables {
  ids: string;
  stepsToSkip?: string | null;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class GuidedCourseNextStepsV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'guidedCourseNextSteps.v1' as const;

  declare id: string;

  declare nextStep: CourseNextStep;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<GuidedCourseNextStepsV1>) {
    super(params);
  }
}
